// extracted by mini-css-extract-plugin
export default {"user-link":"_3F3mI","userLink":"_3F3mI","link-banned":"_3J_6G","linkBanned":"_3J_6G"};